module.exports = __webpack_public_path__ + "static/media/traycorp1.34d056ba.png";